import React from 'react';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const PendingAppointmentTimelineSection = ({ appointments = [], onReview }) => {
  if (!appointments.length) return null;

  return (
    <Stack spacing={0.7} sx={{ px: { xs: 1.35, md: 1.65 }, py: 1 }} aria-label="Appointments needing review">
      <Typography sx={{ fontSize: '0.76rem', fontWeight: 900, color: colors.brand.deep }}>
        Appointment captured · Needs review
      </Typography>
      {appointments.map((appointment) => (
        <ButtonBase
          key={appointment.sourceId}
          aria-label={`Review appointment: ${appointment.title}`}
          onClick={() => onReview?.(appointment)}
          sx={{
            width: '100%', px: 1.1, py: 0.9, borderRadius: 2.5,
            justifyContent: 'space-between', textAlign: 'left',
            bgcolor: alpha(colors.brand.tint, 0.5),
            border: `1px solid ${alpha(colors.brand.deep, 0.35)}`,
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
            <EventRoundedIcon sx={{ color: colors.brand.deep, fontSize: 21 }} />
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.82rem', fontWeight: 900, color: colors.semantic.ink }}>
                {appointment.title}
              </Typography>
              {appointment.originalStatement ? (
                <Typography sx={{ fontSize: '0.78rem', color: colors.semantic.ink2 }}>
                  {appointment.originalStatement}
                </Typography>
              ) : null}
              <Typography sx={{ fontSize: '0.74rem', color: colors.semantic.ink2 }}>
                {[
                  appointment.date ? `Proposed date: ${appointment.date}` : '',
                  appointment.time,
                  appointment.provider,
                  appointment.date ? 'Needs review' : 'Date needs profile timezone',
                ].filter(Boolean).join(' · ')}
              </Typography>
            </Box>
          </Stack>
          <ChevronRightRoundedIcon sx={{ color: colors.brand.deep }} />
        </ButtonBase>
      ))}
    </Stack>
  );
};

export default PendingAppointmentTimelineSection;
